import(/* webpackMode: "eager" */ "/vercel/path0/src/app/design-services/page.tsx");
